import appConst from '../../../../constant/appConstants'


export default {
	...appConst,
	gerepApi: {
		baseUrl: `${window.__SERVER_URL__}/api/preaffiliation`
	}
}
